import { IS_NODE } from "@/__main__/constants.mjs";
import globals from "@/util/global-whitelist.mjs";

// Reads the provided style property from the document root
// Use this to get css root vars like `--transition` or `--sp-container`
// The goal of this function is to avoid exporting vars from style declarations,
// and instead treat the page style as the source of truth
function getRootStyleProperty(name: string): string {
  if (IS_NODE) return "";
  return getComputedStyle(globals.document.body).getPropertyValue(`${name}`);
}

export default getRootStyleProperty;
